import { render, staticRenderFns } from "./settingVip.vue?vue&type=template&id=5eb7533c&scoped=true"
import script from "./settingVip.vue?vue&type=script&lang=js"
export * from "./settingVip.vue?vue&type=script&lang=js"
import style0 from "./settingVip.vue?vue&type=style&index=0&id=5eb7533c&lang=scss"
import style1 from "./settingVip.vue?vue&type=style&index=1&id=5eb7533c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb7533c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eb7533c')) {
      api.createRecord('5eb7533c', component.options)
    } else {
      api.reload('5eb7533c', component.options)
    }
    module.hot.accept("./settingVip.vue?vue&type=template&id=5eb7533c&scoped=true", function () {
      api.rerender('5eb7533c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platList/settingVip.vue"
export default component.exports